module.exports = __webpack_public_path__ + "static/media/collections.json.14ae72aa.bak";


//////////////////
// WEBPACK FOOTER
// ./src/data/collections.json.bak
// module id = 187
// module chunks = 0